import React from "react";
import "./index.css";
import { Item, Value } from "../../types";
import {
  formatExtendedDate,
  formatCategory,
  getParamSearch,
  removeLeadingSlash,
} from "../../utils";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Pagination from "../Pagination";

const ResultList = ({
  items,
  loading,
  totalResults,
  itemsPerPage,
  setItemsPerPage,
  totalPages,
  setTotalPages,
  currentPage,
  setCurrentPage,
}: {
  items: Item[];
  loading: boolean;
  totalResults?: number | null;
  itemsPerPage: number;
  setItemsPerPage: React.Dispatch<React.SetStateAction<number>>;
  totalPages: number;
  setTotalPages: React.Dispatch<React.SetStateAction<number>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}) => {
  return (
    <div>
      {!loading ? (
        <>
          {items.length > 0 ? (
            <div>
              <div style={{ marginBottom: "30px" }}>
                Mostrando <b>{totalResults}</b> resultados para "
                <b>{getParamSearch()}</b>"
              </div>
              <ul style={{ listStyle: "none", padding: "0" }}>
                {items.map((item, index) => (
                  <li key={index}>
                    <a
                      className="d-block mb-5"
                      href={`w/${removeLeadingSlash(item.friendlyUrlPath)}`}
                    >
                      <div className="psp-badge mb-2 psp-search-result-badge">
                        {formatCategory(item.friendlyUrlPath)}
                      </div>{" "}
                      <h2 className="psp-news-title-list psp-search-result-title">
                        {item.title}
                      </h2>{" "}
                      <span className="psp-news-text psp-search-result-description">
                        {formatExtendedDate(new Date(item.datePublished))}
                      </span>{" "}
                    </a>
                  </li>
                ))}
              </ul>
              <div style={{ marginBottom: "20px" }}>
                Exibindo {itemsPerPage} itens por página
              </div>
              <Pagination
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center pt-5 pb-5">
              Nenhum resultado encontrado.
            </div>
          )}
        </>
      ) : (
        <>
          {Array.from({ length: 20 }, (_, idx) => (
            <div key={idx} className="psp-skeleton-search">
              <Skeleton width={"80px"} />
              <Skeleton height={"20px"} />
              <Skeleton width={"150px"} />
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default ResultList;
